(ns dre.i18n.events
  (:require
   [cljs.reader :as edn]
   [clojure.string :as str]
   [day8.re-frame.tracing :refer-macros [fn-traced]]
   [dre.components.flash.events :as-alias flash]
   [dre.config :as conf]
   [dre.i18n.db :refer [init-db]]
   [dre.i18n.utils :refer [decide-language] :as utils]
   [dre.i18n.views :refer [tr]]
   [dre.network :as-alias network]
   [dre.storage.events :as-alias storage]
   [re-frame.core :as rf]
   [superstructor.re-frame.fetch-fx :as-alias fetch-fx]))


(def db-path :i18n)


;; -- Events

(rf/reg-event-fx
  ::init
  (fn-traced
    [{:keys [db]} _]
    {:db (->> init-db
              (merge {:language (conf/->default-language db)})
              (assoc db db-path))
     ::network/request [{:endpoint :i18n/messages}
                        {:request-content-type :text
                         :response-content-type :text
                         :on-success [::setup]
                         :on-failure [::messages-nok]}]}))


(rf/reg-event-fx
  ::messages-nok
  [(rf/path db-path)]
  (fn-traced
    [{db :db} _]
    {:dispatch [::flash/show
                [tr "Failed to load translations. Falling back to %s."
                 (str/upper-case (:language db "EN"))]
                :severity :error]}))


(rf/reg-event-fx
  ::setup
  [(rf/inject-cofx ::storage/get :language) rf/trim-v]
  (fn-traced
    [{:keys [db language]} [{::fetch-fx/keys [response]}]]
    {:db (assoc-in db [db-path :messages] (edn/read-string (:body response)))
     :fx [[:dispatch [::set-lang (decide-language
                                  :preferred language
                                  :supported (apply sorted-set (conf/->supported-languages db))
                                  :default (conf/->default-language db))]]]}))


(rf/reg-event-fx
  ::set-lang
  [rf/trim-v]
  (fn-traced
   [{db :db} [language]]
   (let [supported-languages (->> db conf/->supported-languages (apply sorted-set))]
     (when (contains? supported-languages language)
       {::set-html-lang language
        ::storage/set [:language language]
        :db (assoc-in db [db-path :language] language)}))))


;; -- Effects

(rf/reg-fx
  ::set-html-lang
  (fn [lang]
    (js/document.documentElement.setAttribute "lang" lang)))


;; -- Subscriptions

(rf/reg-sub
  ::state
  (fn [db _]
    (db-path db)))


(rf/reg-sub
 ::translate
 :<- [::state]
 (fn [state [_ msg format-args]]
   (utils/translate state msg format-args)))
